export const FETCH_GASTOS_REQUEST = "FETCH_GASTOS_REQUEST";
export const FETCH_GASTOS_SUCCESS = "FETCH_GASTOS_SUCCESS";
export const FETCH_GASTOS_FAILURE = "FETCH_GASTOS_FAILURE";
